import { render, staticRenderFns } from "./SpuOffSale.vue?vue&type=template&id=5c719eba&scoped=true&"
import script from "./SpuOffSale.vue?vue&type=script&lang=js&"
export * from "./SpuOffSale.vue?vue&type=script&lang=js&"
import style0 from "./SpuOffSale.vue?vue&type=style&index=0&id=5c719eba&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c719eba",
  null
  
)

component.options.__file = "SpuOffSale.vue"
export default component.exports